// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import { get } from 'utilities/objects'

// Redux:
import { getSiteData } from 'actions/site'
import {
	getPageData,
	getPartialPageData,
	receivePartialPage,
	receiveDkeSectionImageUpdated,
	receiveDkeSectionImageGalleryUpdated,
	receiveDkeSectionLinkUpdated,
	receiveDkeSectionFormUpdated,
	receiveDkeSectionMapUpdated,
	receiveDkeSectionAdded,
	receiveDkeSectionRemoved,
	receiveDkeSectionsReordered,
	receiveDkeSectionSettings,
	maybeUpdatePostSets
} from 'actions/page'

class PageData extends React.Component {
	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}

		zenscroll.setup( 400, siteData.scroll_offset )

		this.refresh()

		// Listen for editor events:
		window.addEventListener( 'dkeEditorSiteSettingsUpdated', () => {
			this.siteSettingsUpdated()
		}, false )

		window.addEventListener( 'dkeEditorPageUpdated', () => {
			this.refresh()
		}, false )

		window.addEventListener( 'dkeEditorPagePartiallyUpdated', ( e ) => {
			this.partialRefresh( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorPageDataUpdated', ( e ) => {
			this.pageDataUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorImageUpdated', ( e ) => {
			this.imageUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorImageGalleryUpdated', ( e ) => {
			this.imageGalleryUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorLinkUpdated', ( e ) => {
			this.linkUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionFormUpdated', ( e ) => {
			this.formUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionMapUpdated', ( e ) => {
			this.mapUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionAdded', ( e ) => {
			this.addedSection( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionRemoved', ( e ) => {
			this.removedSection( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionsReordered', ( e ) => {
			this.reorderedSections( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionSettingsUpdated', ( e ) => {
			this.updatedSectionSettings( e.detail )
		}, false )
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		const { dispatch, match, type, history } = this.props
		const { params, path } = match

		const isAppended = this.props.pageOverride ? true : false
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false
		const prevArchivePageNumber = prevParams.archivePageNumber ? prevParams.archivePageNumber : false

		if ( '/' == path && '/' != prevProps.match.path ) {
			this.update( 'page', 'home', false )
		} else if (
			! isAppended &&
			( type != prevProps.type || params.slug != prevParams.slug || archivePageNumber != prevArchivePageNumber )
		) {
			if ( 'POP' == history.action ) {
				// Fade content:
				document.documentElement.classList.add( 'has-transition-page-leaving' )

				setTimeout( () => {
					this.update( type, params.slug, archivePageNumber )

					setTimeout( () => {
						document.documentElement.classList.remove( 'has-transition-page-leaving' )
					}, 400 )
				}, 200 )
			} else {
				this.update( type, params.slug, archivePageNumber )
			}

			// Get posts:
			dispatch( maybeUpdatePostSets( true ) )
		}
	}

	siteSettingsUpdated = () => {
		this.props.dispatch( getSiteData() )
	}

	refresh = () => {
		const { match, type } = this.props
		const { params, path } = match
		const isAppended = this.props.pageOverride ? true : false
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false

		// Fetch new content data:
		if ( '/' == path ) {
			this.update( 'page', 'home', false )
		} else if ( ! isAppended && params.slug ) {
			this.update( type, params.slug, archivePageNumber )
		} else {
			this.update( type, '', archivePageNumber )
		}
	}

	partialRefresh = ( data ) => {
		this.props.dispatch( getPartialPageData( data ) )
	}

	update = ( type, slug, archivePageNumber ) => {
		const { history, dispatch } = this.props
		const locationHash = history.location.hash.slice( 1 )
		const path = location.pathname
		const pathSegments = path.split( '/' ).filter( Boolean )
		const isAppended = this.props.pageOverride ? true : false
		let theSlug = slug,
			categorySlug = '',
			isArchive = false,
			requestOnly = false,
			number = 1

		// For archive pages, use the correct slug and also request archives data:
		switch ( type ) {
			case 'websites':
				type = 'page'
				theSlug = pathSegments[0]
				// requestOnly = true

				dispatch(
					getPageData( {
						type: 'websites',
						isArchive: true,
						slug: '',
						categorySlug: 'latest',
						number: 20,
						archivePageNumber: archivePageNumber,
						requestOnly: false
					} )
				)

				break

			case 'brandings':
				type = 'page'
				theSlug = pathSegments[0]

				dispatch(
					getPageData( {
						type: 'brandings',
						isArchive: true,
						slug: '',
						categorySlug: 'latest',
						number: 20,
						archivePageNumber: archivePageNumber,
						requestOnly: false
					} )
				)

				break

			case 'graphic_designs':
				type = 'page'
				theSlug = pathSegments[0]

				dispatch(
					getPageData( {
						type: 'graphic_designs',
						isArchive: true,
						slug: '',
						categorySlug: 'latest',
						number: 20,
						archivePageNumber: archivePageNumber,
						requestOnly: false
					} )
				)

				break
		}

		// Scroll to the top when not jumping to an anchor:
		if ( ! locationHash && ! isAppended ) {
			zenscroll.toY( 0 )
		}

		dispatch(
			getPageData( {
				type: type,
				isArchive: isArchive,
				slug: theSlug,
				categorySlug: categorySlug,
				number: number,
				archivePageNumber: archivePageNumber,
				requestOnly: requestOnly
			} )
		)
	}

	pageDataUpdated = ( data ) => {
		const id = data.id.replace( '_agd_', '' )
		let dkePageData = {}

		if ( 'show_360south_disclaimer' == id ) {
			// @todo.
			// Update the dkePageData to update the DKE UI.
		}

		this.props.dispatch( receivePartialPage(
			data.slug,
			{
				[ id ]: data.value
			}
		) )
	}

	imageUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionImageUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	imageGalleryUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionImageGalleryUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	linkUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionLinkUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	formUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionFormUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	mapUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionMapUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	addedSection = ( data ) => {
		this.props.dispatch( receiveDkeSectionAdded( data.id, data.data ) )

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	removedSection = ( data ) => {
		this.props.dispatch( receiveDkeSectionRemoved( data ) )

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	reorderedSections = ( data ) => {
		this.props.dispatch( receiveDkeSectionsReordered( data ) )

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	updatedSectionSettings = ( data ) => {
		this.props.dispatch( receiveDkeSectionSettings( data ) )

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	render() {
		return null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		selectedArchive: state.page.selectedArchive
	}
}

export default withRouter(
	connect( mapStateToProps )( PageData )
)



// WEBPACK FOOTER //
// ./containers/PageData.jsx